import { render } from "./mtn.vue?vue&type=template&id=56dbe83e&scoped=true"
import script from "./mtn.vue?vue&type=script&lang=js"
export * from "./mtn.vue?vue&type=script&lang=js"

import "./mtn.vue?vue&type=style&index=0&id=56dbe83e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\admin-tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56dbe83e"]])

export default __exports__